import { render, staticRenderFns } from "./RecorderWork.vue?vue&type=template&id=953030f6&scoped=true"
import script from "./RecorderWork.vue?vue&type=script&lang=js"
export * from "./RecorderWork.vue?vue&type=script&lang=js"
import style0 from "./RecorderWork.vue?vue&type=style&index=0&id=953030f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953030f6",
  null
  
)

export default component.exports